// src/redux/slices/resourceBookmarksSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Load initial bookmarks from localStorage
const loadFromLocalStorage = () => {
  try {
    const stored = localStorage.getItem("bookmarkedResources");
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error("Failed to load bookmarks from localStorage:", e);
    return [];
  }
};

const saveToLocalStorage = (bookmarks) => {
  try {
    localStorage.setItem("bookmarkedResources", JSON.stringify(bookmarks));
  } catch (e) {
    console.error("Failed to save bookmarks to localStorage:", e);
  }
};

const resourceBookmarksSlice = createSlice({
  name: "resourceBookmarks",
  initialState: {
    bookmarkedResources: loadFromLocalStorage(),
  },
  reducers: {
    toggleResourceBookmark: (state, action) => {
      const newResource = action.payload;
      const resourceTitle = newResource.title;

      if (!resourceTitle) {
        console.warn("⚠️ Cannot toggle bookmark: resource has no title.");
        return;
      }

      const index = state.bookmarkedResources.findIndex(
        (resource) => resource.title === resourceTitle
      );

      if (index !== -1) {
        state.bookmarkedResources.splice(index, 1); // remove
      } else {
        state.bookmarkedResources.push(newResource); // add
      }

      // Save to localStorage after change
      saveToLocalStorage(state.bookmarkedResources);
    },
  },
});

export const { toggleResourceBookmark } = resourceBookmarksSlice.actions;
export default resourceBookmarksSlice.reducer;
